var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect, _path18, _g, _path19, _g2, _path20, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 54,
    viewBox: "0 0 111 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.834 9.93908C66.834 10.8979 66.5 11.6386 65.8321 12.1612C65.1641 12.6793 64.2096 12.9383 62.9685 12.9383H58.5411V3.16359H62.6638C65.2408 3.16359 66.5293 3.95202 66.5293 5.52888C66.5293 5.8697 66.4481 6.18325 66.2856 6.46954C66.1232 6.75128 65.8749 6.99895 65.541 7.21253C65.2115 7.42611 64.8482 7.57152 64.451 7.64877V7.67604C64.9114 7.73057 65.3243 7.86917 65.6899 8.09184C66.0555 8.30996 66.3375 8.58489 66.5361 8.91662C66.7347 9.24381 66.834 9.58463 66.834 9.93908ZM63.422 6.04011C63.422 5.43572 62.9504 5.13353 62.0072 5.13353H61.4656V6.98077H62.3118C62.6368 6.98077 62.903 6.89443 63.1106 6.72175C63.3182 6.54452 63.422 6.31731 63.422 6.04011ZM63.7267 9.92545C63.7267 9.6437 63.6251 9.41194 63.422 9.23018C63.219 9.0484 62.9504 8.95752 62.6164 8.95752H61.4656V10.9547H62.4404C62.8376 10.9547 63.1513 10.8638 63.3814 10.6821C63.6116 10.4957 63.7267 10.2435 63.7267 9.92545Z",
    fill: "#9298A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2129 12.9383L73.7865 11.1388H70.889L70.4287 12.9383H67.2672L70.6115 3.16359H74.24L77.3879 12.9383H74.2129ZM72.3716 5.2903H72.3039C72.2949 5.39937 72.2633 5.57887 72.2091 5.8288C72.155 6.07873 71.8819 7.15118 71.39 9.04613H73.2449L72.5679 6.38774C72.4731 5.99694 72.4077 5.63112 72.3716 5.2903Z",
    fill: "#9298A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5252 12.9383V3.16359H81.4498V10.6343H84.794V12.9383H78.5252Z",
    fill: "#9298A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4784 5.46753V12.9383H86.5403V5.46753H83.8257V3.16359H92.2269V5.46753H89.4784Z",
    fill: "#9298A2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.606 12.9383V3.16359H96.5305V12.9383H93.606Z",
    fill: "#9298A2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.663 12.6724C104.859 12.9633 103.932 13.1087 102.88 13.1087C101.847 13.1087 100.956 12.911 100.206 12.5157C99.4573 12.1158 98.8841 11.55 98.4869 10.8184C98.0943 10.0822 97.898 9.23472 97.898 8.27588C97.898 7.24434 98.1191 6.3264 98.5614 5.52206C99.0037 4.71773 99.6288 4.09744 100.437 3.66119C101.244 3.2204 102.174 3 103.226 3C104.065 3 104.878 3.10225 105.663 3.30674V6.02647C105.392 5.86288 105.069 5.73564 104.695 5.64476C104.32 5.55387 103.941 5.50843 103.557 5.50843C102.763 5.50843 102.136 5.73791 101.675 6.19688C101.22 6.65585 100.992 7.27842 100.992 8.06457C100.992 8.84619 101.22 9.4642 101.675 9.91863C102.136 10.3685 102.75 10.5935 103.517 10.5935C104.225 10.5935 104.941 10.4117 105.663 10.0481V12.6724Z",
    fill: "#9298A2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2837 28.9256C65.2837 29.5755 65.11 30.1412 64.7624 30.6229C64.4194 31.1046 63.9365 31.4636 63.3137 31.6999C62.6909 31.9362 61.9417 32.0543 61.0662 32.0543C60.0507 32.0543 59.121 31.8817 58.2771 31.5363V28.8575C58.6833 29.1574 59.1323 29.4005 59.6242 29.5868C60.1162 29.7686 60.5743 29.8595 60.9985 29.8595C61.3189 29.8595 61.5671 29.8027 61.7432 29.6891C61.9192 29.5709 62.0072 29.4005 62.0072 29.1778C62.0072 29.0188 61.962 28.8802 61.8718 28.762C61.786 28.6393 61.6529 28.5257 61.4724 28.4212C61.2964 28.3167 60.9669 28.1736 60.484 27.9918C58.9224 27.3874 58.1417 26.4104 58.1417 25.0607C58.1417 24.1155 58.4982 23.3612 59.2113 22.7977C59.9244 22.2297 60.8811 21.9457 62.0816 21.9457C62.4201 21.9457 62.7315 21.9593 63.0159 21.9865C63.3002 22.0138 63.5574 22.0479 63.7876 22.0888C64.0223 22.1297 64.3495 22.2069 64.7692 22.3206V24.8085C63.9523 24.3587 63.149 24.1337 62.3592 24.1337C62.0343 24.1337 61.7725 24.1951 61.5739 24.3178C61.3753 24.4404 61.276 24.6086 61.276 24.8222C61.276 25.0267 61.355 25.1971 61.513 25.3334C61.6755 25.4652 62.0117 25.6379 62.5217 25.8514C63.5281 26.2604 64.2389 26.708 64.6541 27.1943C65.0739 27.6805 65.2837 28.2576 65.2837 28.9256Z",
    fill: "#9298A2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3832 24.4132V31.8839H68.4452V24.4132H65.7305V22.1092H74.1317V24.4132H71.3832Z",
    fill: "#9298A2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3029 31.8839V22.1092H81.3482V24.4132H78.2274V25.8378H81.1587V28.1417H78.2274V29.58H81.5716V31.8839H75.3029Z",
    fill: "#9298A2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9526 31.8839V22.1092H88.998V24.4132H85.8771V25.8378H88.8084V28.1417H85.8771V29.58H89.2214V31.8839H82.9526Z",
    fill: "#9298A2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6024 31.8839V22.1092H93.5269V29.58H96.8711V31.8839H90.6024Z",
    fill: "#9298A2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7644 50.5638C64.961 50.8546 64.0336 51 62.982 51C61.9485 51 61.0572 50.8023 60.308 50.407C59.5588 50.0071 58.9856 49.4413 58.5885 48.7097C58.1958 47.9735 57.9995 47.126 57.9995 46.1672C57.9995 45.1356 58.2207 44.2177 58.6629 43.4134C59.1052 42.609 59.7303 41.9887 60.5382 41.5525C61.346 41.1117 62.2757 40.8913 63.3273 40.8913C64.1667 40.8913 64.9791 40.9935 65.7644 41.198V43.9178C65.4936 43.7542 65.1709 43.6269 64.7963 43.5361C64.4217 43.4452 64.0426 43.3997 63.659 43.3997C62.8647 43.3997 62.2373 43.6292 61.777 44.0882C61.3212 44.5472 61.0933 45.1697 61.0933 45.9559C61.0933 46.7375 61.3212 47.3555 61.777 47.8099C62.2373 48.2598 62.8511 48.4848 63.6184 48.4848C64.3269 48.4848 65.0423 48.303 65.7644 47.9394V50.5638Z",
    fill: "#9298A2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.274 50.8296V41.0549H73.3193V43.3588H70.1985V44.7835H73.1298V47.0874H70.1985V48.5257H73.5427V50.8296H67.274Z",
    fill: "#9298A2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.707 50.8296L78.2815 46.1127C78.0108 45.74 77.7896 45.4038 77.6181 45.1038H77.591C77.6181 45.5855 77.6316 46.1263 77.6316 46.7261V50.8296H74.9238V41.0549H77.6858L80.9691 45.5401C81.0097 45.5992 81.0594 45.6696 81.118 45.7514C81.1767 45.8332 81.2354 45.9173 81.2941 46.0036C81.3527 46.0899 81.4069 46.174 81.4565 46.2558C81.5107 46.3376 81.5513 46.4103 81.5784 46.4739H81.6055C81.5784 46.274 81.5648 45.9286 81.5648 45.4378V41.0549H84.2727V50.8296H81.707Z",
    fill: "#9298A2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0966 43.3588V50.8296H88.1585V43.3588H85.4439V41.0549H93.8451V43.3588H91.0966Z",
    fill: "#9298A2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0162 50.8296V41.0549H101.062V43.3588H97.9408V44.7835H100.872V47.0874H97.9408V48.5257H101.285V50.8296H95.0162Z",
    fill: "#9298A2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M107.703 50.8296L106.978 48.7233C106.838 48.3098 106.656 47.9849 106.43 47.7486C106.209 47.5123 105.967 47.3941 105.706 47.3941H105.591V50.8296H102.666V41.0549H106.552C107.91 41.0549 108.912 41.2798 109.558 41.7297C110.207 42.1751 110.532 42.8453 110.532 43.7406C110.532 44.4131 110.343 44.9766 109.964 45.431C109.589 45.8854 109.03 46.2149 108.285 46.4194V46.4467C108.696 46.5739 109.036 46.7807 109.307 47.0669C109.582 47.3532 109.828 47.7781 110.045 48.3416L111 50.8296H107.703ZM107.425 44.1564C107.425 43.8292 107.326 43.5701 107.127 43.3793C106.929 43.1884 106.617 43.093 106.193 43.093H105.591V45.3288H106.119C106.511 45.3288 106.827 45.2174 107.066 44.9948C107.306 44.7721 107.425 44.4926 107.425 44.1564Z",
    fill: "#9298A2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    width: 54,
    height: 50,
    rx: 12.8667,
    transform: "rotate(90 50 0)",
    fill: "#80858F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_387_288",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 10,
    width: 25,
    height: 25
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6958 34.6988C18.7177 21.7259 16.0898 13.2452 13.1481 10.6265H23.2479C31.8768 15.6222 29.7849 28.7562 27.6604 34.6988H5.6958Z",
    fill: "#E6E6E6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_387_288)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8.86133,
    y: -0.867432,
    width: 42.827,
    height: 44.0241,
    rx: 3.21667,
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_387_288)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_387_288",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 14,
    width: 24,
    height: 26
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0249 39.0362C25.0468 26.0633 22.4189 17.5826 19.4772 14.9639H29.577C38.2059 19.9596 36.114 33.0936 33.9895 39.0362H12.0249Z",
    fill: "#E0E0E0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_387_288)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.9227,
    height: 38.158,
    rx: 3.21667,
    transform: "matrix(0.773995 -0.633191 0.612175 0.790723 -7.38477 22.7112)",
    fill: "#F1F1F1"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_387_288)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_387_288",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 19,
    width: 25,
    height: 25
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.354 43.3733C31.3759 30.4005 28.748 21.9198 25.8063 19.301H35.9061C44.535 24.2968 42.4431 37.4308 40.3186 43.3733H18.354Z",
    fill: "#E0E0E0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_387_288)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4696,
    height: 37.6065,
    rx: 3.21667,
    transform: "matrix(0.289939 -0.957045 0.952389 0.304884 1.26514 44.6243)",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_387_288",
    x: 6.87823,
    y: 10.675,
    width: 32.4176,
    height: 32.6501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.857779
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.14445
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_387_288"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_387_288",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_387_288",
    x: 13.2073,
    y: 15.0121,
    width: 32.4176,
    height: 32.6501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.857779
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.14445
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_387_288"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_387_288",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logoSmall.412dd5c16789096fe7b546a943b03908.svg";
export { ForwardRef as ReactComponent };